import React from 'react';
import { Center, Box } from '@mantine/core';
import { Link } from 'react-router-dom';
import ForgotPasswordFooter from './ForgotPassword.footer';

const ForgotPasswordContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Center w="100dvw" h="100dvh">
      <Box w="400px">
        <Link to="/login">
          <img alt="Fooda" src="/assets/images/logo.svg" />
        </Link>
        {children}
        <ForgotPasswordFooter />
      </Box>
    </Center>
  );
};

export default ForgotPasswordContainer;
